var t = function t(_t, e) {
  void 0 === e && (e = ["event"]);
  var n = _t.startsWith("$") ? function () {
    return window.$(document).trigger(_t.slice(1), [].slice.call(arguments)[0].detail);
  } : function () {
    var n = arguments,
        i = e.reduce(function (t, e, i) {
      return t[e] = [].slice.call(n)[i], t;
    }, {});
    i.event.target.dispatchEvent(new CustomEvent("$" + _t, {
      detail: i,
      bubbles: !0,
      cancelable: !0
    }));
  };
  return _t.startsWith("$") ? document.addEventListener(_t, n) : window.$(document).on(_t, n), n;
},
    e = function e(t, _e) {
  t.startsWith("$") ? document.removeEventListener(t, _e) : window.$(document).off(t, _e);
};

export { e as abnegate, t as delegate };